import { DateRangePicker } from "@mui/lab";
import { Grid, TextField } from "@mui/material";

import useBreakpoint from "../../common/hooks/useBreakpoint";

const styles = {
  separator: {
    display: { sm: "inline", xs: "none" },
    textAlign: "center",
    lineHeight: "48px",
  },
};

const RangePicker = (props) => {
  const {
    value,
    onChange,
    startText = "Od",
    endText = "Do",
    format = "DD.MM.YYYY",
  } = props;

  const calendars = useBreakpoint("sm") ? 1 : 2;

  return (
    <DateRangePicker
      value={value}
      startText={startText}
      endText={endText}
      inputFormat={format}
      disableMaskedInput={true}
      clearable={true}
      clearText="CLEAR"
      calendars={calendars}
      onChange={(value) => onChange(value)}
      renderInput={(startProps, endProps) => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={5}>
            <TextField {...startProps} fullWidth />
          </Grid>
          <Grid item sm={2} sx={styles.separator}>
            -
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField {...endProps} fullWidth />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default RangePicker;
